import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import ThemeProvider from '../../../../../paymentJourneyRedesign/muiTheme/ThemeProvider';
import FormContainer from '../../../../../paymentJourneyRedesign/shared/formElements/FormContainer';
import CallToAction from '../../../../../shared/CallToAction/CallToAction';
import s from './UpdateForm.module.scss';

export default function UpdateForm(props) {
  const { onSubmit, onCountryChange, defaultValues, children } = props;

  const form = useForm({ defaultValues });

  const {
    watch,
    formState: { isSubmitting },
  } = form;

  const selectedCountry = watch('adHocAnswers.profile.country');

  useEffect(() => {
    if (selectedCountry) {
      onCountryChange(selectedCountry);
    }
  }, [onCountryChange, selectedCountry]);

  return (
    <ThemeProvider>
      <FormContainer form={form} onSubmit={onSubmit}>
        {children}
        <CallToAction
          type="submit"
          disabled={isSubmitting}
          className={s.button}
        >
          Continue
        </CallToAction>
      </FormContainer>
    </ThemeProvider>
  );
}
